import { writable } from 'svelte/store';

export const allElements = writable({});
export const draftElements = writable({});
export const invalidElements = writable({});

export const allActivities = writable({});
export const draftActivities = writable({});
export const invalidActivities = writable({});
export const pendingActivities = writable({});
export const supersededActivities = writable({});

export const allInstances = writable({});
export const scheduledInstances = writable({});
export const inProgressInstances = writable({});
export const archivedInstances = writable({});
export const executedInstances = writable({});

export const dashBoardWorkCentreId = writable(-1);
export const dashboardWorkOrder = writable('');
